import React from 'react';
import { ThemeToggle as SharedThemeToggle } from '@packages/ui';
import { useThemeStore } from '../stores/themeStore';

interface ThemeToggleProps {
  compact?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ compact = false }) => {
  const { mode, setMode } = useThemeStore();

  return (
    <SharedThemeToggle
      compact={compact}
      mode={mode}
      onModeChange={setMode}
      labels={{
        light: '亮色',
        dark: '暗色',
        system: '系统',
      }}
    />
  );
};

export default ThemeToggle;
